import { Checkbox, type CheckboxProps } from '@mantine/core';

export function CircleCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      {...props}
      styles={{
        input: {
          borderRadius: '50%',
        },
        icon: {
          borderRadius: '50%',
        },
      }}
    />
  );
}
